export const css = {
    root: '_1fpwwgWc',
    splash: '_3PyUhiG3',
    ' _key': 'certwise-theme/certwise/lcc-app/splash'
};
export default css;
